import SiIdCard from '@/icons/SiIdCard';
import { useCompany } from '@/services/api/hooks/companies';
import { usePartner } from '@/services/api/hooks/partners';
import { RoleType } from '@/services/authentication/hooks/user';
import { useCatalogueService } from '@/services/catalogue/useCatalogueService';
import { FC, PropsWithChildren } from 'react';
import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
  en: {
    catalogue: "You are viewing {0}'s catalogue"
  }
});

const Banner: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="text-primary-800 border-primary-200 flex items-center gap-2 rounded-md border bg-[#F3FCFE] px-3 py-1.5 font-medium">
      <SiIdCard className="relative -top-[0.1] text-2xl" />
      <span className="text-sm font-medium">{children}</span>
    </div>
  );
};

export const ImpersonationBanner: FC = () => {
  const configuration = useCatalogueService(state => state.configuration);

  if (configuration.for === RoleType.Company && configuration.as !== RoleType.Company) {
    const CompanyMessage = () => {
      const [company] = useCompany(configuration.partnerId, configuration.companyId);
      return <Banner>{strings.formatString(strings.catalogue, company.name)}</Banner>;
    };
    return <CompanyMessage />;
  }

  if (configuration.for === RoleType.Partner && configuration.as !== RoleType.Partner) {
    const PartnerMessage = () => {
      const [partner] = usePartner(configuration.partnerId);
      return <Banner>{strings.formatString(strings.catalogue, partner.name)}</Banner>;
    };
    return <PartnerMessage />;
  }

  return null;
};
